let folder = 'technology/google-marketing-platform-partner'
export const state = () => ({
  meta: null,
  stage: null,
  benefits: null,
  journey: null,
  caseStudy: null,
  more: null,
  contact: null
})
export const getters = {
  meta(state) {
    return state.meta
  },
  stage(state) {
    return state.stage
  },
  benefits(state) {
    return state.benefits
  },
  journey(state) {
    return state.journey
  },
  caseStudy(state) {
    return state.caseStudy
  },
  more(state) {
    return state.more
  },
  contact(state) {
    return state.contact
  }
}
export const mutations = {
  setMeta(state, { data }) {
    state.meta = data
  },
  setStage(state, { data }) {
    state.stage = data
  },
  setBenefits(state, { data }) {
    state.benefits = data
  },
  setJourney(state, { data }) {
    state.journey = data
  },
  setCaseStudy(state, { data }) {
    state.caseStudy = data
  },
  setMore(state, { data }) {
    state.more = data
  },
  setContact(state, { data }) {
    state.contact = data
  }
}
export const actions = {
  getMeta({ commit, rootState }, { detailFolder }) {
    return this.$axios
      .get(`${rootState.language}/homepage/${folder}/${detailFolder}/meta.json`)
      .then((res) => {
        commit('setMeta', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getStage({ commit, rootState }, { detailFolder }) {
    return this.$axios
      .get(
        `${rootState.language}/homepage/${folder}/${detailFolder}/stage.json`
      )
      .then((res) => {
        commit('setStage', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getBenefits({ commit, rootState }, { detailFolder }) {
    return this.$axios
      .get(
        `${rootState.language}/homepage/${folder}/${detailFolder}/benefits.json`
      )
      .then((res) => {
        commit('setBenefits', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getJourney({ commit, rootState }, { detailFolder }) {
    return this.$axios
      .get(
        `${rootState.language}/homepage/${folder}/${detailFolder}/journey.json`
      )
      .then((res) => {
        commit('setJourney', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getCaseStudy({ commit, rootState }, { detailFolder }) {
    return this.$axios
      .get(
        `${rootState.language}/homepage/${folder}/${detailFolder}/casestudy.json`
      )
      .then((res) => {
        commit('setCaseStudy', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getMore({ commit, rootState }, { detailFolder }) {
    return this.$axios
      .get(`${rootState.language}/homepage/${folder}/${detailFolder}/more.json`)
      .then((res) => {
        commit('setMore', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getContact({ commit, rootState }, { detailFolder }) {
    return this.$axios
      .get(
        `${rootState.language}/homepage/${folder}/${detailFolder}/contact.json`
      )
      .then((res) => {
        commit('setContact', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  }
}
